var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v(" Alterar Data Formação ")])]), _c('div', {
    staticClass: "container dialog"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-2"
  }, [_c('v-col', {
    staticClass: "d-block",
    attrs: {
      "cols": "12"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "500"
    },
    attrs: {
      "for": "motivoAlteracao"
    }
  }, [_vm._v(" Motivo de alteração* ")]), _c('v-textarea', {
    attrs: {
      "id": "motivoAlteracao",
      "counter": 400,
      "maxlength": "400",
      "outlined": "",
      "dense": "",
      "rules": [_vm.$required]
    },
    model: {
      value: _vm.form.motivoAlteracao,
      callback: function ($$v) {
        _vm.$set(_vm.form, "motivoAlteracao", $$v);
      },
      expression: "form.motivoAlteracao"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('sigfoco-date-picker', {
    attrs: {
      "label": "Nova Data Início*",
      "dataEdicao": _vm.form.dataInicio,
      "outlined": "",
      "removeIcon": "",
      "dense": "",
      "rules": [function (v) {
        return !!v || 'Campo obrigatório';
      }, function () {
        return _vm.validateData() || 'Selecione um intervalo de datas válido para continuar.';
      }]
    },
    model: {
      value: _vm.form.dataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.form, "dataInicio", $$v);
      },
      expression: "form.dataInicio"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "label": "Nova Data Fim*",
      "dataEdicao": _vm.form.dataFim,
      "outlined": "",
      "removeIcon": "",
      "dense": "",
      "rules": [function (v) {
        return !!v || 'Campo obrigatório';
      }, function () {
        return _vm.validateData() || 'Selecione um intervalo de datas válido para continuar.';
      }]
    },
    model: {
      value: _vm.form.dataFim,
      callback: function ($$v) {
        _vm.$set(_vm.form, "dataFim", $$v);
      },
      expression: "form.dataFim"
    }
  })], 1)], 1) : _vm._e()], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.reagendar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }